// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".social-icons {\n  display: flex;\n  flex-direction: row;\n  font-size: 28px;\n  color: #000104; }\n  .social-icons .separador {\n    height: 32px;\n    margin: 0 10px;\n    border: 1px solid #7C878E; }\n", ""]);
// Exports
module.exports = exports;
